import React, {useEffect, useState} from 'react';
import {inject, observer} from "mobx-react";
import { Link } from "react-router-dom";
import "./InvoiceReviewList.scss";
import Stores from "app/constants/Stores";

import {
    Button, Collapse, Col, Row,
    Pagination, Input, Form,
    Table, PageHeader, Space, DatePicker, Select, Alert, Spin, Image, Divider, TableColumnGroupType, Card, Avatar, List, Grid
} from "antd";
import {
    FolderViewOutlined,
    FileExcelOutlined
} from '@ant-design/icons';
import i18next from "i18next";
import GetInvoiceReviewRequest from "../../handlers/get/GetInvoiceReviewRequest";
import UserContext from "../../../../identity/contexts/UserContext";
import InvoiceReviewColumns from "./InvoiceReviewColumns";
import InvoiceReviewStore from "../../stores/InvoiceReviewStore";

import ExportExcel from "../../../../app/utils/ExportExcel";
import Constants from "../../../../app/constants/Constants";
import { keys } from 'mobx';
import InvoiceReviewItem from 'reports/InvoiceReview/handlers/get/InvoiceReviewItem';
import GetInvoiceReviewViewModel from 'reports/InvoiceReview/view-models/GetInvoiceReviewViewModel';
import GetInvoiceReviewResponse from 'reports/InvoiceReview/handlers/get/GetInvoiceReviewResponse';
import Meta from 'antd/lib/card/Meta';
import Item from 'antd/lib/list/Item';

const { Panel } = Collapse;
const { Option } = Select;


interface InvoiceReviewListProps {
    invoiceReviewStore?: InvoiceReviewStore
    
    
}

const InvoiceReviewList: React.FC<InvoiceReviewListProps> = inject(Stores.invoiceReviewStore)(observer(({invoiceReviewStore}) => {
    const [dataFetched, setDataFetched] = React.useState(false);
    const [carOptions, setCarOptions] = React.useState([]);
    const [branchOptions, setBranchOptions] = React.useState([]);
    const [companyOptions, setCompanyOptions] = React.useState([]);
    const [serviceMasterOptions, setServiceMasterOptions] = React.useState([]);

    
   
    const formItemLayout = {
        labelCol: {
            xs: { span: 24 },
            sm: { span: 24 },
        },
        wrapperCol: {
            xs: { span: 24 },
            sm: { span: 24 },
        },
    };
    const [form] = Form.useForm();
    InvoiceReviewColumns.forEach(w => {
       w.title = i18next.t(w.title);
    });

    const companyColumn = {title: i18next.t("InvoiceReviewes.Label.companyName"), dataIndex: "companyName", key: "companyName", responsive: ['md']};
   
    
    const columns: any[] = [...InvoiceReviewColumns,
        {
        title: i18next.t("General.Column.Action"),
        dataIndex: 'operation',
        key: 'action',
        fixed: 'right',
        render: (text, record) => (
            <div className="inline">

            

                <Image
                   width={200}
                   src={'data:image/png;base64,' + ""}
                fallback="data:image/png;base64," 
                />
{/*

         viewModel?.invoiceReviewResponse?.invoicePumpPhoto}
         { dataIndex: "invoicePumpPhoto", key: "invoicePumpPhoto", responsive: ['md']}}
                <Link to={`/app/invoiceDetail/${record.invoiceId}`}>
                    <Button type="default"  icon={<FolderViewOutlined />}
                            title={i18next.t("InvoiceReviewes.Button.InvoiceDetail")} style={{ background: "green", borderColor: "white" }}/>

                            
                </Link>

        */}
             

            </div>
        )
    }];
    if(UserContext.info.role == 100)
    {
        columns.unshift(companyColumn);
    }

    useEffect(() => {
        onLoad();

        return onUnload;
    }, []);

    async function onLoad() {
       
        invoiceReviewStore.onInvoiceReviewGetPageLoad();
        invoiceReviewStore.getInvoiceReviewViewModel.getInvoiceReviewesRequest = new GetInvoiceReviewRequest();
        invoiceReviewStore.getInvoiceReviewViewModel.getInvoiceReviewesRequest.pageSize = 20;
        invoiceReviewStore.getInvoiceReviewViewModel.getInvoiceReviewesRequest.pageIndex = 0;
        invoiceReviewStore.getInvoiceReviewViewModel.getInvoiceReviewesRequest.companyId = UserContext.info.role === 1 ? UserContext.info.id : undefined;
        invoiceReviewStore.getInvoiceReviewViewModel.getInvoiceReviewesRequest.companyBranchId = UserContext.info.role === 5 ? UserContext.info.id : undefined;


        try {
            if(UserContext.info.role === 100) {
                await invoiceReviewStore.listCompanyViewModel.getCompanyList();
                let companyOptions = [];
                if (invoiceReviewStore.listCompanyViewModel) {
                    for (let item of invoiceReviewStore.listCompanyViewModel.listCompanyResponse.items) {
                        companyOptions.push(<Option key={item.key} value={item.key}>{item.title}</Option>);
                    }
                }
                setCompanyOptions(companyOptions);
            }
            if(UserContext.info.role === 1) {
                await invoiceReviewStore.listBranchViewModel.getBranchList();
                let branchOptions = [];
                if (invoiceReviewStore.listBranchViewModel) {
                    for (let item of invoiceReviewStore.listBranchViewModel.listBranchResponse.items) {
                        branchOptions.push(<Option key={item.key} value={item.key}>{item.title}</Option>);
                    }
                }
                setBranchOptions(branchOptions);
            }

            await invoiceReviewStore.listCarViewModel.getCarList();
            let carOptions = [];
            if (invoiceReviewStore.listCarViewModel) {
                if(UserContext.info.role !== 5) {
                    for (let item of invoiceReviewStore.listCarViewModel.listCarResponse.items) {
                        carOptions.push(<Option key={item.key} value={item.carNumber}>{item.carNumber}</Option>);
                    }
                }
                else{
                    const filteredCars = invoiceReviewStore.listCarViewModel.listCarResponse.items.filter(w => w.branchId == UserContext.info.id);
                    for (let item of filteredCars) {
                        carOptions.push(<Option key={item.key} value={item.carNumber}>{item.carNumber}</Option>);
                    }
                }
            }
            setCarOptions(carOptions);

            await invoiceReviewStore.listServiceMasterViewModel.getServiceMasterList();
            let serviceMasterOptions = [];
            if (invoiceReviewStore.listServiceMasterViewModel) {
                for (let item of invoiceReviewStore.listServiceMasterViewModel.listServiceMasterResponse.items) {
                    serviceMasterOptions.push(<Option key={item.key} value={item.title}>{item.title}</Option>);
                }
            }
            setServiceMasterOptions(serviceMasterOptions);

            setDataFetched(true);
            
        }
        catch {

        }
    }

    let viewModel = invoiceReviewStore.getInvoiceReviewViewModel;

    if (!viewModel) return;

    function onUnload() {
        invoiceReviewStore.onInvoiceReviewGetPageUnload();
        setServiceMasterOptions([]);
        setCompanyOptions([]);
        setBranchOptions([]);
        setCarOptions([]);
    }

    async function pageIndexChanged(pageIndex, pageSize){
        viewModel.getInvoiceReviewesRequest.pageSize = pageSize;
        viewModel.getInvoiceReviewesRequest.pageIndex = pageIndex - 1;
        await invoiceReviewStore.getInvoiceReviewViewModel.getAllInvoiceReview(viewModel.getInvoiceReviewesRequest);
    }
    async function pageSizeChanged(current, pageSize){
        viewModel.getInvoiceReviewesRequest.pageSize = pageSize;
        viewModel.getInvoiceReviewesRequest.pageIndex = 0;
        await invoiceReviewStore.getInvoiceReviewViewModel.getAllInvoiceReview(viewModel.getInvoiceReviewesRequest);
    }
    function onChanged(e){
        viewModel.getInvoiceReviewesRequest[`${e.target.id}`] = e.target.value;
    }

    function onSelectChanged(e, propName){
        
        viewModel.getInvoiceReviewesRequest[`${propName}`] = e;
        if(propName === "companyId") {
            let carOptions = [];
            const filteredCars = invoiceReviewStore.listCarViewModel.listCarResponse.items.filter(w => w.companyId == e);
            for (let item of filteredCars) {
                carOptions.push(<Option key={item.key} value={item.carNumber}>{item.carNumber}</Option>);
            }
            setCarOptions(carOptions);

            let branchOptions = [];
            const filteredBranches = invoiceReviewStore.listBranchViewModel.listBranchResponse.items.filter(w => w.companyId == e);
            for (let item of filteredBranches) {
                branchOptions.push(<Option key={item.key} value={item.key}>{item.title}</Option>);
            }
            setBranchOptions(branchOptions);
        }
        if(propName === "companyBranchId") {
            let carOptions = [];
            const filteredCars = invoiceReviewStore.listCarViewModel.listCarResponse.items.filter(w => w.branchId == e);
            for (let item of filteredCars) {
                carOptions.push(<Option key={item.key} value={item.carNumber}>{item.carNumber}</Option>);
            }
            setCarOptions(carOptions);
        }
    }
    function onDateChange(date, dateString, prop) {
        viewModel.getInvoiceReviewesRequest[`${prop}`] = dateString;
    }
    async function onFinish(values: any) {
        viewModel.getInvoiceReviewesRequest.pageIndex = 0;
        await viewModel.getAllInvoiceReview(viewModel.getInvoiceReviewesRequest);
    }
    async function onReset(){
        const pageSize = viewModel.getInvoiceReviewesRequest.pageSize;
        viewModel.getInvoiceReviewesRequest = new GetInvoiceReviewRequest();
        viewModel.getInvoiceReviewesRequest.pageIndex = 0;
        viewModel.getInvoiceReviewesRequest.pageSize = pageSize;
        if(UserContext.info.role == 1){
            invoiceReviewStore.getInvoiceReviewViewModel.getInvoiceReviewesRequest.companyId = UserContext.info.id;
        }
        await viewModel.getAllInvoiceReview(viewModel.getInvoiceReviewesRequest);
        form.resetFields();
    }
    async function ExportToExcel(){
        viewModel.invoiceReviewExport = [];
        await viewModel.getAllInvoiceReview(viewModel.getInvoiceReviewesRequest, true);
        if(viewModel.invoiceReviewExport && viewModel.invoiceReviewExport?.length > 0) {
            columns.pop();
            ExportExcel(columns, viewModel?.invoiceReviewExport, "InvoiceReview");
        }
    }

    return (
        <div>
            <PageHeader
                ghost={false}
                onBack={() => window.history.back()}
                title={i18next.t("InvoiceReviewes.Page.Title")}
                subTitle={i18next.t("InvoiceReviewes.Page.SubTitle")}
                extra={[
                    <Button key={"ExportExcel"} className={"button-section"} type="primary" loading={viewModel?.isProcessing} icon={<FileExcelOutlined />} onClick={ExportToExcel}>
                        {i18next.t("General.Button.ExportExcel")}
                    </Button>
                    ,
                ]}
            />

            <Collapse defaultActiveKey={['1']}>
                <Panel header={i18next.t("General.SearchPanel.Text")}  key="1">
                    <Form {...formItemLayout} layout={"vertical"} onFinish={onFinish} form={form}
                          key={"searchForm"}
                          scrollToFirstError>
                        <div>
                        {dataFetched ?
                        <Row gutter={[24, 16]}>
                            {UserContext.info.role === 100 ?
                                <Col span={8}>
                                    <Form.Item name="companyId" initialValue={viewModel?.getInvoiceReviewesRequest?.companyId}
                                               key={"companyId"}
                                               label={i18next.t("InvoiceReviewes.SearchPanel.Label.companyName")}>
                                        {/*<Input onChange={onChanged}/>*/}
                                        <Select style={{width: "100%", display:"block"}} allowClear={true}
                                                showSearch={true} onChange={(e) => onSelectChanged(e, "companyId")}>
                                            {companyOptions}
                                        </Select>
                                    </Form.Item>
                                </Col>: ""}
                            {/*<Col span={8}>
                                <Form.Item name="companyBranchName" initialValue={viewModel?.getInvoiceReviewesRequest?.companyBranchName}
                                           key={"companyBranchName"}
                                           label={i18next.t("InvoiceReviewes.SearchPanel.Label.companyBranchName")}>
                                    <Input onChange={onChanged}/>
                                    <Select style={{width: "100%", display:"block"}}
                                            showSearch={true} onChange={(e) => onSelectChanged(e, "companyBranchName")}>
                                        {petropayAccountOptions}
                                    </Select>
                                </Form.Item>
                            </Col>*/}
                            {UserContext.info.role === 1 ?
                            <Col span={8}>
                                <Form.Item name="companyBranchId" initialValue={viewModel?.getInvoiceReviewesRequest?.companyBranchId}
                                           key={"companyBranchId"}
                                           label={i18next.t("InvoiceReviewes.SearchPanel.Label.companyBranchName")}>
                                    {/*<Input onChange={onChanged} />*/}
                                    <Select style={{width: "100%", display:"block"}} allowClear={true}
                                            showSearch={true} onChange={(e) => onSelectChanged(e, "companyBranchId")}>
                                        {branchOptions}
                                    </Select>
                                </Form.Item>
                            </Col> : "" }
                            <Col span={8}>
                                <Form.Item name="carIdNumber" initialValue={viewModel?.getInvoiceReviewesRequest?.carIdNumber}
                                           key={"carIdNumber"}
                                           label={i18next.t("InvoiceReviewes.SearchPanel.Label.carIdNumber")}>
                                    {/*<Input onChange={onChanged}/>*/}
                                    <Select style={{width: "100%", display:"block"}} allowClear={true}
                                            showSearch={true} onChange={(e) => onSelectChanged(e, "carIdNumber")}>
                                        {carOptions}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item name="invoiceId" initialValue={viewModel?.getInvoiceReviewesRequest?.invoiceId}
                                           key={"invoiceId"}
                                           label={i18next.t("InvoiceReviewes.SearchPanel.Label.invoiceId")}>
                                    <Input type={"number"} onChange={onChanged}/>
                                </Form.Item>
                            </Col>

                            <Col span={8}>
                                <Form.Item name="serviceDescription" initialValue={viewModel?.getInvoiceReviewesRequest?.serviceDescription}
                                           key={"serviceDescription"}
                                           label={i18next.t("InvoiceReviewes.SearchPanel.Label.serviceDescription")}>
                                    {/*<Input onChange={onChanged}/>*/}
                                    <Select style={{width: "100%", display:"block"}} allowClear={true}
                                            showSearch={true} onChange={(e) => onSelectChanged(e, "serviceDescription")}>
                                        {serviceMasterOptions}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item name="invoiceDataTimeFrom" initialValue={viewModel?.getInvoiceReviewesRequest?.invoiceDataTimeFrom}
                                           key={"invoiceDataTimeFrom"}
                                           label={i18next.t("InvoiceReviewes.SearchPanel.Label.invoiceDataTimeFrom")}>
                                    <DatePicker format={Constants.dateFormat} onChange={((date, dateString) => onDateChange(date, dateString, "invoiceDataTimeFrom"))} />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item name="invoiceDataTimeTo" initialValue={viewModel?.getInvoiceReviewesRequest?.invoiceDataTimeTo}
                                           key={"invoiceDataTimeTo"}
                                           label={i18next.t("InvoiceReviewes.SearchPanel.Label.invoiceDataTimeTo")}>
                                    <DatePicker format={Constants.dateFormat} onChange={((date, dateString) => onDateChange(date, dateString, "invoiceDataTimeTo"))} />
                                </Form.Item>
                            </Col>
                                </Row>
                                    :
                                    <Row gutter={[24, 16]}>
                                        <Col offset={11} span={8}>
                                            <Spin className={"spine"} size="large" />
                                        </Col>
                                    </Row>}
                            </div>
                        <PageHeader
                            ghost={false}
                            subTitle={<div>
                                {viewModel?.errorMessage &&
                                <Alert message={viewModel?.errorMessage} type="error" />
                                }
                            </div>}
                            extra={[
                                <Button type="primary" className={"button-section"} loading={viewModel.isProcessing} onClick={onReset} danger key="reset" size={"large"} htmlType="reset">
                                    {i18next.t("General.SearchPanel.ResetButton")}
                                </Button>,
                                <Button type="primary" className={"button-section"} loading={viewModel.isProcessing} key="submit" size={"large"} htmlType="submit">
                                    {i18next.t("General.SearchPanel.SearchButton")}
                                </Button>
                            ]}
                        />
                    </Form>
                </Panel>
            </Collapse>
            <br/>

           <List 
           grid={{ gutter: 16, column: 4 }}
           dataSource={viewModel?.invoiceReviewList} 
           renderItem={(item)=>{
                return(
                 

                    
                    <Card className='cardClass' key={item.invoiceId} bordered={true}  title= {item.invoiceId} >
                      
                   
                      <Meta className='cardTextClass' title={item.stationNameAr }  />
                      <Meta className='cardTextClass' title={item.carIdNumber} />
                       

                       
                        <Image
                            width="100%" height="100%"
                            className="ant-image"
                            src={'data:image/png;base64,' + item.invoicePumpPhoto}
                            fallback="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg=="
                        />
                        
                            <h1 className='cardTextClass' > {item.invoiceAmount}  </h1>
                            <h1 className='cardTextClass' >  {item.invoiceFuelConsumptionLiter}  </h1>
                            
                            <Image
                            width="100%" 
                            className="ant-image"
                            src={'data:image/png;base64,' + item.invoicePlatePhoto}
                            //fallback="NULL"
                        />
                        <h1 className='cardTextClass' >  {item.invoiceOdometer}  </h1>

                    </Card>
                  

                    
                );

           }}
           
           
           >


           </List>

                



                            

                            

            
            
            
            
                 







            <br/>
            <Pagination
                total={viewModel?.totalSize}
                showSizeChanger
                showQuickJumper
                defaultPageSize={20}
                onChange={pageIndexChanged}
                onShowSizeChange={pageSizeChanged}
                showTotal={total => `Total ${total} items`}
            />
        </div>
    )
}));


export default InvoiceReviewList;


